import { render, staticRenderFns } from "./Spread.vue?vue&type=template&id=754de297&scoped=true&"
import script from "./Spread.vue?vue&type=script&lang=ts&"
export * from "./Spread.vue?vue&type=script&lang=ts&"
import style0 from "./Spread.vue?vue&type=style&index=0&id=754de297&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754de297",
  null
  
)

export default component.exports